import { SlidersHorizontal } from "lucide-react";

export function SettingsSystemPage() {
  return (
    <div className="card">
      <div
        className="card__body"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "64px 24px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: 12,
            background: "var(--surface-alt)",
            display: "grid",
            placeItems: "center",
            color: "var(--green-primary)",
            marginBottom: 16,
          }}
        >
          <SlidersHorizontal size={22} />
        </div>
        <h2 className="h-section" style={{ marginBottom: 6 }}>
          System Settings
        </h2>
        <p className="t-muted" style={{ maxWidth: 380, fontSize: 14 }}>
          System configuration options will be available here soon.
        </p>
      </div>
    </div>
  );
}
